"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OidcProvider = void 0;
const react_1 = __importStar(require("react"));
const oidc_1 = __importDefault(require("./vanilla/oidc"));
const OidcRoutes_1 = __importDefault(require("./core/routes/OidcRoutes"));
const index_1 = require("./core/default-component/index");
const ServiceWorkerNotSupported_component_1 = __importDefault(require("./core/default-component/ServiceWorkerNotSupported.component"));
const AuthenticateError_component_1 = __importDefault(require("./core/default-component/AuthenticateError.component"));
const defaultEventState = { name: "", data: null };
const OidcSession = ({ loadingComponent, children, configurationName }) => {
    const [loading, setLoading] = (0, react_1.useState)(true);
    const getOidc = oidc_1.default.get;
    const oidc = getOidc(configurationName);
    (0, react_1.useEffect)(() => {
        let isMounted = true;
        if (oidc) {
            oidc.tryKeepExistingSessionAsync().then(() => {
                if (isMounted) {
                    setLoading(false);
                }
            });
        }
        return () => {
            isMounted = false;
        };
    }, [oidc, configurationName]);
    const LoadingComponent = loadingComponent;
    return (react_1.default.createElement(react_1.default.Fragment, null, loading ? (react_1.default.createElement(LoadingComponent, { configurationName: configurationName })) : (react_1.default.createElement(react_1.default.Fragment, null, children))));
};
const Switch = ({ isLoading, loadingComponent, children, configurationName }) => {
    const LoadingComponent = loadingComponent;
    if (isLoading) {
        return react_1.default.createElement(LoadingComponent, { configurationName: configurationName }, children);
    }
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
const OidcProvider = ({ children, configuration, configurationName = "default", callbackSuccessComponent = index_1.CallBackSuccess, authenticatingComponent = index_1.Authenticating, loadingComponent = index_1.Loading, serviceWorkerNotSupportedComponent = ServiceWorkerNotSupported_component_1.default, authenticatingErrorComponent = AuthenticateError_component_1.default, sessionLostComponent = index_1.SessionLost, onSessionLost = null, onLogoutFromAnotherTab = null, onLogoutFromSameTab = null, withCustomHistory = null, onEvent = null, }) => {
    const getOidc = (configurationName = "default") => {
        return oidc_1.default.getOrCreate(configuration, configurationName);
    };
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [event, setEvent] = (0, react_1.useState)(defaultEventState);
    const [currentConfigurationName, setConfigurationName] = (0, react_1.useState)("default");
    (0, react_1.useEffect)(() => {
        const oidc = getOidc(configurationName);
        const newSubscriptionId = oidc.subscriveEvents((name, data) => {
            if (onEvent) {
                onEvent(configurationName, name, data);
            }
        });
        return () => {
            const previousOidc = getOidc(configurationName);
            previousOidc.removeEventSubscription(newSubscriptionId);
        };
    }, [configurationName, onEvent]);
    (0, react_1.useEffect)(() => {
        const oidc = getOidc(configurationName);
        const newSubscriptionId = oidc.subscriveEvents((name, data) => {
            if (name == oidc_1.default.eventNames.refreshTokensAsync_error || name == oidc_1.default.eventNames.syncTokensAsync_error) {
                if (onSessionLost != null) {
                    onSessionLost();
                    return;
                }
                setEvent({ name, data });
            }
            else if (name === oidc_1.default.eventNames.logout_from_another_tab) {
                if (onLogoutFromAnotherTab != null) {
                    onLogoutFromAnotherTab();
                    return;
                }
                setEvent({ name, data });
            }
            else if (name === oidc_1.default.eventNames.logout_from_same_tab) {
                if (onLogoutFromSameTab != null) {
                    onLogoutFromSameTab();
                    return;
                }
                //setEvent({name, data});
            }
            else if (name == oidc_1.default.eventNames.loginAsync_begin
                || name == oidc_1.default.eventNames.loginCallbackAsync_end
                || name == oidc_1.default.eventNames.loginAsync_error
                || name == oidc_1.default.eventNames.loginCallbackAsync_error) {
                setEvent({ name, data });
            }
            else if (name == oidc_1.default.eventNames.service_worker_not_supported_by_browser && configuration.service_worker_only === true) {
                setEvent({ name, data });
            }
        });
        setConfigurationName(configurationName);
        setLoading(false);
        return () => {
            const previousOidc = getOidc(configurationName);
            previousOidc.removeEventSubscription(newSubscriptionId);
            setEvent(defaultEventState);
        };
    }, [configuration, configurationName]);
    const SessionLostComponent = sessionLostComponent;
    const AuthenticatingComponent = authenticatingComponent;
    const LoadingComponent = loadingComponent;
    const ServiceWorkerNotSupportedComponent = serviceWorkerNotSupportedComponent;
    const AuthenticatingErrorComponent = authenticatingErrorComponent;
    const isLoading = (loading || (currentConfigurationName != configurationName));
    const oidc = getOidc(configurationName);
    let eventName = event.name;
    switch (eventName) {
        case oidc_1.default.eventNames.service_worker_not_supported_by_browser:
            return react_1.default.createElement(Switch, { loadingComponent: LoadingComponent, isLoading: isLoading, configurationName: configurationName },
                react_1.default.createElement(ServiceWorkerNotSupportedComponent, { configurationName: configurationName }));
        case oidc_1.default.eventNames.loginAsync_begin:
            return react_1.default.createElement(Switch, { loadingComponent: LoadingComponent, isLoading: isLoading, configurationName: configurationName },
                react_1.default.createElement(AuthenticatingComponent, { configurationName: configurationName }));
        case oidc_1.default.eventNames.loginAsync_error:
        case oidc_1.default.eventNames.loginCallbackAsync_error:
            return react_1.default.createElement(Switch, { loadingComponent: LoadingComponent, isLoading: isLoading, configurationName: configurationName },
                react_1.default.createElement(AuthenticatingErrorComponent, { configurationName: configurationName }));
        case oidc_1.default.eventNames.refreshTokensAsync_error:
        case oidc_1.default.eventNames.syncTokensAsync_error:
        case oidc_1.default.eventNames.logout_from_another_tab:
            return react_1.default.createElement(Switch, { loadingComponent: LoadingComponent, isLoading: isLoading, configurationName: configurationName },
                react_1.default.createElement(SessionLostComponent, { configurationName: configurationName }));
        default:
            return (react_1.default.createElement(Switch, { loadingComponent: LoadingComponent, isLoading: isLoading, configurationName: configurationName },
                react_1.default.createElement(OidcRoutes_1.default, { redirect_uri: oidc.configuration.redirect_uri, silent_redirect_uri: oidc.configuration.silent_redirect_uri, silent_login_uri: oidc.configuration.silent_login_uri, callbackSuccessComponent: callbackSuccessComponent, callbackErrorComponent: authenticatingErrorComponent, authenticatingComponent: authenticatingComponent, configurationName: configurationName, withCustomHistory: withCustomHistory },
                    react_1.default.createElement(OidcSession, { loadingComponent: LoadingComponent, configurationName: configurationName }, children))));
    }
};
exports.OidcProvider = OidcProvider;
exports.default = exports.OidcProvider;
//# sourceMappingURL=OidcProvider.js.map